import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useRedirectAreaForm } from './hook';
import { RedirectAreaData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    REDIRECT_AREA,
    REDIRECT_AREA_DETAIL,
    REDIRECT_AREA_EDIT,
    REDIRECT_AREA_NEW,
} from '../../../../../routes/paths';
import { RedirectAreaParamsHistorical } from '../historical';

export const RedirectAreaForm = () => {
    const {
        redirectArea,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikRedirectAreaData,
        redirectAreaHistorical,
        showHistorical,
        setShowHistorical,
    } = useRedirectAreaForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    redirectArea && redirectArea.id
                        ? 'Editar área redirección PQR'
                        : 'Crear área redirección PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={redirectArea?.id || ''}
                        buttonCreate={{
                            show: Boolean(redirectArea?.id),
                            route: REDIRECT_AREA_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: REDIRECT_AREA,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: REDIRECT_AREA_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: REDIRECT_AREA_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(redirectArea?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <RedirectAreaParamsHistorical
                        historical={redirectAreaHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <RedirectAreaData
                data={redirectArea}
                onChangeFormik={(formik) => setFormikRedirectAreaData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
